import { URL_CANDIDATES_RECOMMENDED } from '@seek/adv-constants';

import type { UrlResolver } from 'src/types';

export const buildTalentSearchJobUrl = (
  jobId: string,
  urlResolver: UrlResolver,
) => urlResolver({ path: `${URL_CANDIDATES_RECOMMENDED}?jobId=${jobId}` });
